export default __webpack_public_path__ + "static/media/backIcon.ea82e369.svg";